import { render, staticRenderFns } from "./lista_editoriales.vue?vue&type=template&id=0fec7a66&scoped=true"
import script from "./lista_editoriales.vue?vue&type=script&lang=js"
export * from "./lista_editoriales.vue?vue&type=script&lang=js"
import style0 from "./lista_editoriales.vue?vue&type=style&index=0&id=0fec7a66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec7a66",
  null
  
)

export default component.exports